import { Account } from "../../../api/dealer/DealerApi";
import { RBACRolesResponse } from "../../../api/rbac/types";
import { FeatureToggleDetail } from "../../../pages/featureToggles/types";
import { isRBACEnabledForDealerFacingRole } from "../RBACAccessCheck";
import { RBACAccessState } from "./reducer";

export const userDetailsPromise = (state: RBACAccessState) =>
  new Promise<RBACRolesResponse>((resolve, reject) => {
    handlePromise(
      state.userRoleDetails,
      (value) => {
        resolve(value);
      },
      (value) => {
        reject(value);
      }
    );
  });

export const featureTogglesPromise = (state: RBACAccessState) =>
  new Promise<FeatureToggleDetail[]>((resolve, reject) => {
    handlePromise(
      state.featureToggles,
      (value) => {
        resolve(value);
      },
      (value) => {
        reject(value);
      }
    );
  });

export const accountTogglesPromise = (state: RBACAccessState) =>
  new Promise<{ data: Account[] }>((resolve, reject) => {
    handlePromise(
      state.accountDetails,
      (value) => {
        resolve(value);
      },
      (value) => {
        reject(value);
      }
    );
  });

export function resolvePromise<T>(
  promise: PromiseSettledResult<T> | PromiseRejectedResult | undefined
) {
  return promise?.status === "fulfilled" ? promise.value : undefined;
}

function handlePromise<T>(
  promise: PromiseSettledResult<T> | PromiseRejectedResult | undefined,
  fulfilled: (value: T) => void,
  rejected: (value: any) => void
) {
  if (promise?.status === "fulfilled") {
    fulfilled(promise.value);
  }
  if (promise?.status === "rejected") {
    rejected(promise.reason);
  }
}

export function canValidateRBACForDealerFacingRole(
  state: RBACAccessState,
  enableFTRBAC: boolean
): boolean {
  return (
    !state.rbacEnabled &&
    enableFTRBAC &&
    state.dataLoaded &&
    !state.toggleProcessed
  );
}

export function isRBACEnabledForDealerRoles(state: RBACAccessState): {
  toggleProcessed: boolean;
  rbacEnabled: boolean;
} {
  const { data } = resolvePromise(state.accountDetails) || {};
  const { toggleProcessed, rbacEnabled } = isRBACEnabledForDealerFacingRole({
    accounts: data,
    featureToggles: resolvePromise(state.featureToggles),
  });
  return { toggleProcessed, rbacEnabled };
}
